import api from './api';
import type { Paginated, Wallet } from '../types/api';

export async function listWallets() {
  const { data } = await api.get<Paginated<Wallet> | Wallet[]>('/finance/wallets/');
  return Array.isArray(data) ? data : data.results;
}

export async function deposit(walletId: number, amount: string, description: string) {
  await api.post(`/finance/wallets/${walletId}/deposit/`, { amount, description });
}

export async function adjustBalance(
  walletId: number,
  amount: string,
  direction: 'credit' | 'debit',
  reason: string,
) {
  const { data } = await api.post<Wallet>(
    `/finance/wallets/${walletId}/adjust-balance/`,
    { amount, direction, reason },
  );
  return data;
}
